<template>
  <div id="promo-report-page" class="mkt-ops -main-font">
    <div
      style="position: absolute; top: 50%; left: 52%; width: 10%; z-index: 2"
      v-show="loadData == true"
      :class="hideoverlay ? 'bg-overlay-unset' : ''"
    >
      <md-progress-spinner
        :md-stroke="8"
        :md-diameter="65"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>

    <div class="head-page">
      <div class="-title">SUMMARY REPORT</div>
      <div class="-filter">
        <md-field class="box">
          <md-select
            class="status-type"
            v-model="selectedMenu"
            @md-selected="onChangeMenu"
          >
            <md-option
              class="latofont"
              v-for="(item, index) in filterMenu"
              :key="index"
              v-bind:value="item"
              >{{ item }}</md-option
            >
          </md-select>
        </md-field>
      </div>
    </div>

    <md-card class="main-content" style="margin-top: 8px">
      <div class="md-layout md-gutter" style="margin-top: 0px">
        <div
          class="
            md-layout-item
            md-large-size-50
            md-medium-size-50
            md-small-size-50
            md-xsmall-hide
          "
        >
          <div class="right-filter-search -first">
            <div class="title-search" style="width: 20%; padding-top: 5px">
              PO Date
            </div>
            <div style="width: 29%">
              <div class="mkt-datepicker">
                <md-datepicker
                  ref="startdate"
                  v-model="vStartDate"
                  md-immediately
                ></md-datepicker>
              </div>
            </div>
            <div style="width: 22%; padding-top: 5px; text-align: center">
              End Date
            </div>
            <div style="width: 29%">
              <div class="mkt-datepicker">
                <md-datepicker
                  ref="enddate"
                  class
                  v-model="vEndDate"
                  md-immediately
                ></md-datepicker>
              </div>
            </div>
          </div>

          <div style="margin-top: 15px; display: flex">
            <div style="width: 100%; display: flex">
              <div style="width: 20%; height: 45px; display: table">
                <span style="vertical-align: middle; display: table-cell"
                  >Product Code</span
                >
              </div>

              <div style="width: 80%">
                <search-box-dropdown
                  :typeSearch="true"
                  :menuSelected="
                    selectedMenu === 'Promotion'
                      ? 'Promotion'
                      : 'Volume Discount'
                  "
                  @addproduct="addProduct"
                ></search-box-dropdown>
              </div>
            </div>
          </div>

          <md-card
            class="box-filter-search"
            style="width: 100%; margin-left: 0px"
          >
            <div
              v-for="number in countRowChipsProduct"
              :key="number"
              style="width: 100%; display: flex"
            >
              <template v-for="(items, idix) in dataChipsProduct">
                <div :key="idix" style="width: 20%" v-if="items.row === number">
                  <div class="tab-chip" :title="items.label">
                    <div class="-primary">
                      {{ items.id }}
                    </div>
                    <span
                      class="tab-chip -delete"
                      @click="deleteChipsProduct(items, idix)"
                    >
                      <i class="material-icons">close</i>
                    </span>
                  </div>
                </div>
              </template>
            </div>
          </md-card>

          <div class="right-filter-search">
            <div class="title-search" style="height: 45px; padding-top: 15px">
              <span style="vertical-align: middle; display: table-cell"
                >Cust Code</span
              >
            </div>
            <div style="width: 80%">
              <multiselect
                v-model="selectedCustomer"
                label="title_th"
                track-by="code"
                placeholder="Search Customer Code or Name"
                :open-direction="'bottom'"
                :options="optionsCustomer"
                :searchable="true"
                :max-height="180"
                :show-no-results="false"
                :custom-label="customLabelCustomer"
                :select-label="''"
                :deselect-label="''"
                :selected-label="''"
                :hide-selected="true"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <div>
                    <div class="-label">
                      {{ option.code }} - {{ option.title_th }}
                    </div>
                    <div
                      class="-delete"
                      @mousedown.prevent.stop="
                        clearAll(option.code, 'customer')
                      "
                    >
                      <i class="material-icons">close</i>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
        </div>

        <div
          class="
            md-layout-item
            md-large-size-50
            md-medium-size-50
            md-small-size-50
            md-xsmall-hide
          "
          style="padding-left: 35px"
        >
          <div style="display: flex; margin-top: 35px" class="ckb-report">
            <div
              v-if="selectedMenu === 'Volume Discount'"
              style="display: flex"
            >
              <label class="-mkt-checkbox-container">
                <input type="checkbox" v-model="checkedAllPromotion" />
                <span class="-mkt-checkbox"></span>
              </label>
              <div>
                All Volume Discount
                <!-- {{
                  selectedMenu === "Promotion"
                    ? "All Promotion"
                    : "All Volume Discount"
                }} -->
              </div>
            </div>

            <div v-if="selectedMenu === 'Promotion'" style="display: flex">
              <md-radio
                v-model="radioPromotion"
                value="active"
                @change="condPromotion()"
              ></md-radio>
              <div>Active Promotion</div>
            </div>

            <div
              v-if="selectedMenu === 'Promotion'"
              style="display: flex; margin-left: 25px"
            >
              <!-- <label class="-mkt-checkbox-container">
                <input type="checkbox" v-model="checkedActivePromotion" />
                <span class="-mkt-checkbox"></span>
              </label> -->
              <md-radio
                v-model="radioPromotion"
                value="inactive"
                @change="condPromotion()"
              ></md-radio>
              <div>Inactive Promotion</div>
            </div>

            <div
              v-if="selectedMenu === 'Promotion'"
              style="display: flex; margin-left: 25px"
            >
              <md-radio
                v-model="radioPromotion"
                value="all"
                @change="condPromotion()"
              ></md-radio>
              <div>All Promotion</div>
            </div>
          </div>

          <div style="margin-top: 15px; display: flex">
            <div
              v-if="selectedMenu === 'Promotion'"
              style="width: 100%; display: flex"
            >
              <div style="width: 20%; height: 50px; display: table">
                <span style="vertical-align: middle; display: table-cell"
                  >My Promotions</span
                >
              </div>
              <div style="width: 80%">
                <multiselect
                  v-show="selectedMenu === 'Promotion'"
                  v-model="selectedPromotion"
                  label="promotion_title"
                  track-by="promotion_code"
                  placeholder="Search Promotion"
                  :open-direction="'bottom'"
                  :options="optionsPromotion"
                  :searchable="true"
                  :max-height="180"
                  :show-no-results="false"
                  :custom-label="customLabelPromotion"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="''"
                  :hide-selected="true"
                  @select="setDataFilter"
                  @close="onClosePromotion"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <div>
                      <div class="-label">
                        {{
                          option.promotion_code +
                          " [" +
                          option.promotion_title +
                          "]"
                        }}
                      </div>
                      <div
                        class="-delete"
                        @mousedown.prevent.stop="
                          clearAll(option.promotion_code, 'promotion')
                        "
                      >
                        <i class="material-icons">close</i>
                      </div>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>

            <div v-else style="width: 100%; display: flex">
              <div style="width: 25%; height: 50px; display: table">
                <span style="vertical-align: middle; display: table-cell"
                  >Volume Discount</span
                >
              </div>
              <div style="width: 75%">
                <multiselect
                  v-show="selectedMenu === 'Volume Discount'"
                  v-model="selectedVD"
                  label="h_name"
                  track-by="vd_id"
                  placeholder="Search Volume Discount"
                  :open-direction="'bottom'"
                  :options="optionsVD"
                  :searchable="true"
                  :max-height="180"
                  :show-no-results="false"
                  :custom-label="customLabelVD"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="''"
                  :hide-selected="true"
                  @select="setDataFilter"
                  @close="onCloseVD"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <div>
                      <div class="-label">
                        {{ option.h_name }}
                      </div>
                      <div
                        class="-delete"
                        @mousedown.prevent.stop="
                          clearAll(option.h_name, 'voldiscount')
                        "
                      >
                        <i class="material-icons">close</i>
                      </div>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>

          <md-card
            class="box-filter-search"
            style="width: 100%; margin-left: 0px"
          >
            <div v-for="(items, idx) in filterChips" :key="items.keyId">
              <div class="tab-chip" :title="showTitleChip(items)">
                <div class="-primary">
                  {{ labelChip(items) }}
                </div>
                <span
                  class="tab-chip -delete"
                  @click="deleteFilter(items, idx)"
                >
                  <i class="material-icons">close</i>
                </span>
              </div>
            </div>
          </md-card>

          <div class="right-filter-search">
            <div class="title-search" style="height: 45px; padding-top: 15px">
              <span style="vertical-align: middle; display: table-cell"
                >Salesman Code</span
              >
            </div>
            <div style="width: 55%">
              <multiselect
                v-model="selectedSmCode"
                label="title_th"
                track-by="code"
                placeholder="Search Salesman Code"
                :open-direction="'bottom'"
                :options="optionsSmCode"
                :searchable="true"
                :max-height="180"
                :show-no-results="false"
                :custom-label="customLabelSmCode"
                :select-label="''"
                :deselect-label="''"
                :selected-label="''"
                :hide-selected="true"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <div>
                    <div class="-label">{{ option.code }}</div>
                    <div
                      class="-delete"
                      @mousedown.prevent.stop="clearAll(option.code, 'sm_code')"
                    >
                      <i class="material-icons">close</i>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>

            <div style="width: 25%; margin: auto; text-align: center">
              <md-button
                class="md-raised md-primary search-report"
                @click="searchReport()"
                >SEARCH</md-button
              >
            </div>
          </div>
        </div>

        <div class="md-layout md-gutter">
          <div class="md-layout-item chart md-size-100">
            <label v-if="selectedMenu === 'Promotion'" class="sub-title"
              >CHART SUMMARY PROMOTION</label
            >
            <label v-else class="sub-title"
              >CHART SUMMARY VOLUME DISCOUNT</label
            >
          </div>

          <div
            class="
              md-layout-item
              md-large-size-75
              md-medium-size-75
              md-small-size-75
              md-xsmall-hide
            "
            style="margin-bottom: 20px; padding: 0px"
          >
            <chart
              class="chart-line"
              :options="optionsChart"
              ref="lineChart"
              style="width: 100%"
            ></chart>
          </div>

          <div
            class="
              md-layout-item
              md-large-size-25
              md-medium-size-25
              md-small-size-25
              md-xsmall-hide
            "
            style="margin-bottom: 20px; margin-top: 55px; padding: 0px"
          >
            <md-card class="box-detail-chart">
              <div style="font-weight: bold !important; font-size: 14px">
                Summary
              </div>
              <div class="-total">
                <div class="-title" style="width: 50%">Total Customer</div>
                <div class="-value" style="width: 50%">
                  {{ chartSummaryCustomer }} &nbsp; &nbsp; Shop
                </div>
              </div>
              <div class="-total">
                <div class="-title" style="width: 40%">Total Order</div>
                <div class="-value" style="width: 60%">
                  {{ chartSummaryOrder }} &nbsp; Order
                </div>
              </div>
              <!-- <div class="-total" style="border-bottom: 1px solid #dadada; padding-bottom: 10px;"> -->
              <div class="-total">
                <div class="-title" style="width: 37%">Total Amount</div>
                <!-- <div class="-value" style="width: 65%;">{{chartSummaryAmount}} &nbsp; &nbsp; Baht</div> -->
                <div class="-value" style="width: 63%">
                  {{ formatNumber(totalAmount, 2) }} &nbsp; &nbsp; Baht
                </div>
              </div>
              <!-- <div class="-total">
                        <div class="-title" style="width: 40%;">Total Invoice</div>
                        <div class="-value" style="width: 60%;">{{chartNetAmountLine}} &nbsp; &nbsp; Line</div>
                    </div>
                    <div class="-total">
                        <div class="-title" style="width: 40%;">Total Invoice</div>
                        <div class="-value" style="width: 60%;">{{chartSummaryNetAmount}} &nbsp; &nbsp; Baht</div>
                    </div> -->
            </md-card>

            <div
              class="
                md-layout-item
                -detail
                md-large-size-100
                md-medium-size-100
                md-small-size-100
                md-xsmall-hide
              "
            >
              <div
                style="display: flex"
                v-for="(item, rIndex) in optionsChart.series"
                :key="rIndex"
              >
                <div
                  class="circle-2017"
                  v-bind:style="{ backgroundColor: item.lineStyle.color }"
                ></div>
                <div class="-series">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </md-card>

    <md-card class="main-content">
      <div
        class="md-layout-item list-data md-size-100"
        style="display: flex; padding: 0px"
      >
        <div
          v-if="selectedMenu === 'Promotion'"
          class="md-layout-item list-data md-size-55"
        >
          <label class="sub-title">LIST OF PROMOTIONS SORTED BY</label>
        </div>

        <!-- <div v-else class="md-layout-item list-data md-size-55"> -->
        <div v-else class="md-layout-item list-data md-size-70">
          <label class="sub-title">LIST OF VOLUME DISCOUNT SORTED BY</label>
        </div>

        <!-- TAB -->
        <div
          v-show="selectedMenu === 'Promotion'"
          class="md-layout-item list-data md-size-15 custom-tab"
          :style="
            datableTabBy === '0'
              ? 'border-bottom: 3px solid #3f51b5;'
              : 'border-bottom: 3px solid #e5e5e5;'
          "
        >
          <label
            class="sub-title-tab"
            style="cursor: pointer"
            @click="changeTab('0')"
            >SUMMARY</label
          >
        </div>
        <div
          class="md-layout-item list-data md-size-15 custom-tab"
          :style="
            datableTabBy === '1'
              ? 'border-bottom: 3px solid #3f51b5;'
              : 'border-bottom: 3px solid #e5e5e5;'
          "
        >
          <label
            class="sub-title-tab"
            style="cursor: pointer"
            @click="changeTab('1')"
            >BY PO</label
          >
        </div>

        <div
          class="md-layout-item list-data md-size-15"
          style="text-align: end; padding-top: 0px"
        >
          <md-button
            class="md-raised md-primary"
            style="
              width: 30px;
              min-width: 30px;
              height: 30px;
              background: #fd7f00;
              margin: 10px 15px 0 0;
            "
            title="Export by PO"
            @click="exportReportItem('promotion')"
          >
            <i class="md-icon material-icons">file_download</i>
          </md-button>

          <md-button
            class="md-raised md-primary"
            style="
              width: 30px;
              min-width: 30px;
              height: 30px;
              background: #fd7f00;
              margin: 10px 5px 0 0;
            "
            title="Export by Items"
            @click="exportReportItem('item')"
          >
            <i class="md-icon material-icons">file_download</i>
          </md-button>
        </div>
      </div>

      <div class="md-layout-item table-data md-size-100">
        <!-- START SELECT PROMOTION -->
        <!-- TAB SUMMARY -->
        <div
          id="table-report"
          v-if="selectedMenu === 'Promotion' && datableTabBy === '0'"
        >
          <div id="divHeadList">
            <div style="width: 45%">Promotion Code</div>
            <div style="width: 10%" class="-text-right">No. Outlet</div>
            <div style="width: 15%" class="-text-right">Sum PO</div>
            <div style="width: 15%" class="-text-right">Amount</div>
            <div style="width: 15%" class="-text-right">Inv Amount</div>
          </div>
          <div id="divBodyList" @scroll="handleScroll">
            <div
              v-show="tbListReport == null || tbListReport.length == 0"
              :class="'row-bg-gray'"
              style="display: block; text-align: center"
            >
              No data in table.
            </div>
            <div
              :class="'row-bg-gray'"
              v-for="(item, rIndex) in tbListReport"
              :key="rIndex"
            >
              <div style="width: 45%" class="nowrap-title -font-kanit">
                <span :title="item.promo_code">{{ item.promo_code }}</span>
              </div>
              <div style="width: 10%" class="-text-right">
                <span>{{ formatNumber(item.sum_customer, 2) }}</span>
              </div>
              <div style="width: 15%" class="-text-right">
                <span>{{ formatNumber(item.sum_po, 2) }}</span>
              </div>
              <div style="width: 15%" class="-text-right">
                <span>{{ formatNumber(item.amount, 2) }}</span>
              </div>
              <div style="width: 15%" class="-text-right">
                <span>{{ formatNumber(item.inv_total_amount, 2) }}</span>
              </div>
            </div>
          </div>
          <div id="divTableFoot">
            <div style="width: 85%" class="-text-right">
              Sum Total : &emsp; {{ formatNumber(totalAmount, 2) }}
            </div>
            <div style="width: 15%" class="-text-right">
              {{ formatNumber(totalNetAmount, 2) }}
            </div>
          </div>
        </div>

        <!-- TAB PO -->
        <div
          id="table-report"
          v-else-if="selectedMenu === 'Promotion' && datableTabBy === '1'"
        >
          <div id="divHeadList">
            <!-- <div style="width: 6%;"></div> -->
            <div style="width: 8%">Cust Code</div>
            <div style="width: 24%">Cust Name</div>
            <div style="width: 7%" class="-text-center">No.</div>
            <div style="width: 12.5%">Promotion Code</div>
            <div style="width: 7%" class="-text-center">Salesman</div>
            <div style="width: 9%">PO No.</div>
            <div style="width: 9%" class="-text-center">PO date</div>
            <div style="width: 8%" class="-text-right">Amount</div>
            <div style="width: 7.5%">Inv No.</div>
            <div style="width: 8%" class="-text-right">Inv Amount</div>
          </div>
          <div id="divBodyList" @scroll="handleScroll">
            <div
              v-show="tbListReport == null || tbListReport.length == 0"
              :class="'row-bg-gray'"
              style="display: block; text-align: center"
            >
              No data in table.
            </div>
            <div
              :class="'row-bg-gray'"
              v-for="(item, rIndex) in tbListReport"
              :key="rIndex"
            >
              <!-- <div style="width: 6%;">
                            <div class="circle-green -text-center"></div>
                        </div> -->
              <div style="width: 8%">
                <span>{{ item.cust_code }}</span>
              </div>
              <div style="width: 24%" class="nowrap-title -font-kanit">
                <span :title="item.customer_name_th">{{
                  item.customer_name_th
                }}</span>
              </div>
              <div style="width: 7%" class="-text-center">
                <span>{{ item.no }}</span>
              </div>
              <div style="width: 12.5%" class="nowrap-title -font-kanit">
                <span :title="item.promo_code">{{ item.promo_code }}</span>
              </div>
              <div style="width: 7%" class="-text-center">
                <span>{{ item.sm_code }}</span>
              </div>
              <div style="width: 9%" class="nowrap-title -font-kanit">
                <span :title="item.po_no">{{ item.po_no }}</span>
              </div>
              <div style="width: 9%" class="-text-center">
                <span>{{ formatDate(item.po_date) }}</span>
              </div>
              <div style="width: 8%" class="-text-right">
                <span>{{ formatNumber(item.sum_by_set, 2) }}</span>
              </div>
              <div style="width: 7.5%">
                <span>{{ item.inv_no }}</span>
              </div>
              <div style="width: 8%" class="-text-right">
                <span>{{ formatNumber(item.inv_total_amount, 2) }}</span>
              </div>
            </div>
          </div>
          <div id="divTableFoot">
            <div style="width: 39%"></div>
            <div style="width: 12.5%">
              Count Promotion : {{ formatNumber(totalPromotion, 0) }}
            </div>
            <div style="width: 16%">
              Sum QTY : {{ formatNumber(totalQty, 0) }}
            </div>
            <div style="width: 9%" class="-text-right">Sum Total :</div>
            <div style="width: 8%" class="-text-right">
              {{ formatNumber(totalAmount, 2) }}
            </div>
            <div style="width: 7.5%"></div>
            <div style="width: 8%" class="-text-right">
              {{ formatNumber(totalNetAmount, 2) }}
            </div>
          </div>
        </div>
        <!-- END SELECT PROMOTION -->

        <!-- START SELECT VD -->
        <div id="table-report" v-if="selectedMenu === 'Volume Discount'">
          <div id="divHeadList">
            <!-- <div style="width: 6%;"></div> -->
            <div style="width: 6.5%">Cust Code</div>
            <div style="width: 19%">Cust Name</div>
            <div style="width: 7%" class="-text-center">No.</div>
            <div style="width: 19%">Volume Discount</div>
            <div style="width: 7%" class="-text-center">Salesman</div>
            <div style="width: 9%">PO No.</div>
            <div style="width: 9%" class="-text-center">PO date</div>
            <div style="width: 8%" class="-text-right">Amount</div>
            <div style="width: 7.5%">Inv No.</div>
            <div style="width: 8%" class="-text-right">Inv Amount</div>
          </div>
          <div id="divBodyList" @scroll="handleScroll">
            <div
              v-show="tbListReport == null || tbListReport.length == 0"
              :class="'row-bg-gray'"
              style="display: block; text-align: center"
            >
              No data in table.
            </div>
            <div
              :class="'row-bg-gray'"
              v-for="(item, rIndex) in tbListReport"
              :key="rIndex"
            >
              <!-- <div style="width: 6%;">
                            <div class="circle-green -text-center"></div>
                        </div> -->
              <div style="width: 6.5%">
                <span>{{ item.cust_code }}</span>
              </div>
              <div style="width: 19%" class="nowrap-title -font-kanit">
                <span :title="item.customer_name_th">{{
                  item.customer_name_th
                }}</span>
              </div>
              <div style="width: 7%" class="-text-center">
                <span>{{ item.no }}</span>
              </div>
              <div style="width: 19%" class="nowrap-title -font-kanit">
                <span :title="item.h_name">{{ item.h_name }}</span>
              </div>
              <div style="width: 7%" class="-text-center">
                <span>{{ item.sm_code }}</span>
              </div>
              <div style="width: 9%" class="nowrap-title -font-kanit">
                <span :title="item.po_no">{{ item.po_no }}</span>
              </div>
              <div style="width: 9%" class="-text-center">
                <span>{{ formatDate(item.po_date) }}</span>
              </div>
              <div style="width: 8%" class="-text-right">
                <span>{{ formatNumber(item.sum_by_set, 2) }}</span>
              </div>
              <div style="width: 7.5%">
                <span>{{ item.inv_no }}</span>
              </div>
              <div style="width: 8%" class="-text-right">
                <span>{{ formatNumber(item.inv_total_amount, 2) }}</span>
              </div>
            </div>
          </div>
          <div id="divTableFoot">
            <div style="width: 39%"></div>
            <div style="width: 12.5%">
              Count VD : {{ formatNumber(totalVD, 0) }}
            </div>
            <div style="width: 16%">
              Sum QTY : {{ formatNumber(totalQty, 0) }}
            </div>
            <div style="width: 9%" class="-text-right">Sum Total :</div>
            <div style="width: 8%" class="-text-right">
              {{ formatNumber(totalAmount, 2) }}
            </div>
            <div style="width: 7.5%"></div>
            <div style="width: 8%" class="-text-right">
              {{ formatNumber(totalNetAmount, 2) }}
            </div>
          </div>
        </div>
        <!-- END SELECT VD -->
      </div>
    </md-card>

    <!-- <md-dialog
      :md-active.sync="showFilterDialog"
      class="filter-dialog"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title>Add Filters</md-dialog-title>
      <div class="layout-dialog">
        <multiselect
          v-model="filterProductGroup"
          label="label"
          track-by="id"
          :placeholder="placeholderPro"
          :options="productGroups"
          :searchable="true"
          :max-height="235"
          :show-no-results="false"
          :select-label="''"
          :deselect-label="''"
          :selected-label="''"
          :hide-selected="true"
          :custom-label="customLabel"
        >
          <template slot="singleLabel" slot-scope="{ option }">
            <div>
              <div class="-label">{{ option.id }} - {{ option.label }}</div>
              <div
                class="-delete"
                @mousedown.prevent.stop="clearAll(option.id, 'productgroup')"
              >
                <i class="material-icons">close</i>
              </div>
            </div>
          </template>
        </multiselect>
      </div>

      <md-dialog-actions class="-action">
        <md-button @click="closeFilterDialog" class="md-cancel"
          >cancel</md-button
        >
        <md-button class="md-primary" @click="addCondFilter"
          >add filter</md-button
        >
      </md-dialog-actions>
    </md-dialog> -->

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ dContent }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import Chart from "vue-echarts/components/ECharts";
import "echarts/lib/chart/line";
import "echarts/lib/chart/scatter";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import moment from "moment-timezone";
import promotionService from "@/services/promotion";
import PricingService from "@/services/pricing";
import searchBoxDropdown from "@/components/shared/search-box-dropdown";

export default {
  name: "promotion-report",
  components: {
    Chart,
    searchBoxDropdown,
  },
  created() {
    // this.getAllProductGroup();
    // this.getAllProductGroupVD();
    this.getDataList();
    this.getAllPromotion();
    this.getAllVD();
    this.getAllCustomer();
    this.getAllSmCode();
    this.$store.dispatch("pmcreate/getCustomerGroups");
    // this.$store.dispatch("pmcreate/getProductGroups");

    let date = moment(new Date());
    let year = parseInt(date.format("YYYY"));
    this.optionsChart.legend.data = [];
    this.optionsChart.series = [];
    this.optionsChart.series[0] = {
      name: "Year [" + year + "]",
      data: "",
      type: "line",
      itemStyle: { color: this.colorChartSeries[0] },
      lineStyle: { color: this.colorChartSeries[0] },
    };

    this.optionsChart.yAxis.min = 0;
    this.optionsChart.yAxis.max = 100;

    let today = new Date();
    this.vStartDate = new Date(today.getFullYear(), today.getMonth(), 1);
    this.vEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  },
  data: () => ({
    checkedAllPromotion: false,
    checkedActivePromotion: false,
    amountPeriod: {},
    filterMenu: ["Promotion", "Volume Discount"],
    selectedMenu: "Promotion",
    selectedVD: [],
    optionsVD: [],
    productGroups: [],
    dataProductGroups: [],
    dataProductGroupsVD: [],
    totalAmount: 0,
    totalNetAmount: 0,
    totalVD: 0,
    totalPromotion: 0,
    totalQty: 0,
    showFilterDialog: false,
    filterProductGroup: [],
    filterCustGroup: [],
    placeholderPro: "Filter by Product or Product Group",
    placeholderCust: "Filter by Customer Group",
    filterChipsSearch: [],
    loadData: false,
    dContent: "",
    showSnackbar: false,
    position: "center",
    duration: 4000,
    isInfinity: false,
    filterChips: [],
    selectedPromotion: [],
    optionsPromotion: [],
    selectedCustomer: [],
    optionsCustomer: [],
    selectedSmCode: [],
    optionsSmCode: [],
    vStartDate: null,
    vEndDate: null,
    slcProduct: 0,
    track: ["Track"],
    tbListReport: [],
    chartSummaryCustomer: 0,
    chartNetAmountLine: 0,
    chartSummaryOrder: 0,
    chartSummaryNetAmount: 0,
    colorChartSeries: [
      "#32bbda",
      "#8fb93e",
      "#e61a8b",
      "#c23531",
      "#2f4554",
      "#61a0a8",
      "#d48265",
      "#91c7ae",
      "#ca8622",
      "#749f83",
      "#bda29a",
      "#546570",
      "#c4ccd3",
    ],
    // loadPage: 1,
    startPage: 0,
    scrollStart: [0],
    dataChipsProduct: [],
    countRowChipsProduct: 0,
    rowChipsProduct: 1,
    hideoverlay: false,
    datableTabBy: "1",
    radioPromotion: "active",
    radioPromotionSearch: "active",
    oldTab: "1",
  }),
  watch: {
    vStartDate() {
      if (
        this.$refs.startdate !== undefined &&
        this.$refs.startdate.$el.children[3] !== undefined
      ) {
        this.$refs.startdate.$el.children[2].addEventListener(
          "click",
          this.clearstartdate,
          false
        );
      }
    },
    vEndDate() {
      if (
        this.$refs.enddate !== undefined &&
        this.$refs.enddate.$el.children[3] !== undefined
      ) {
        this.$refs.enddate.$el.children[2].addEventListener(
          "click",
          this.clearenddate,
          false
        );
      }
    },
  },
  computed: {
    customerGroups() {
      return this.$store.getters["pmcreate/customer_groups"];
    },
    // productGroups() {
    //     return this.$store.getters["pmcreate/product_groups"];
    // }
    optionsChart() {
      // let amountPeriod = this.amountPeriod;
      // let amountPeriod = {
      //   2022: [null, null, "5591160.16"],
      // };
      // console.log("amountPeriod ==>", amountPeriod);
      return {
        title: {
          text: "CHART SUMMARY PROMOTION",
          x: "center",
          textStyle: {
            color: "#a2a0a0",
            fontWeight: "bold",
            fontFamily: "lato",
            fontSize: 15,
          },
          show: false,
        },
        tooltip: {
          trigger: "axis",
          // formatter: "Temperature : <br/>{a} : {b} : {c} : {d}"
          // formatter: function (params) {
          //   // console.log("params ==>", params);
          //   var colorSpan = (color) =>
          //     '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' +
          //     color +
          //     '"></span>';
          //   // let rez = '<p>' + params[0].axisValue + '</p>';
          //   let rez = params[0].axisValue + "<br>";
          //   // console.log(params); //quite useful for debug

          //   let year = params[0].seriesName.substring(6, 10);
          //   let arrMonth = [
          //     "Jan",
          //     "Feb",
          //     "Mar",
          //     "Apr",
          //     "May",
          //     "Jun",
          //     "Jul",
          //     "Aug",
          //     "Sep",
          //     "Oct",
          //     "Nov",
          //     "Dec",
          //   ];
          //   let month =
          //     arrMonth.findIndex((item) => item === params[0].name) + 1;
          //   // console.log("year,month ==>", year, month);
          //   // let amount = amountPeriod[year][month]
          //   //   ? amountPeriod[year][month]
          //   //   : 0;
          //   let amount = this.amountPeriod[year][month]
          //     ? this.amountPeriod[year][month]
          //     : 0;
          //   // let amount = 0;

          //   params.forEach((item) => {
          //     // console.log(item); //quite useful for debug
          //     // var xx = '<p>'   + colorSpan(item.color) + ' ' + item.seriesName + ': ' + item.data + '%' + '</p>'
          //     var xx =
          //       "</p>" +
          //       colorSpan(item.color) +
          //       " " +
          //       item.seriesName +
          //       " : " +
          //       item.data +
          //       " - Amount : " +
          //       amount.toLocaleString(undefined, {
          //         minimumFractionDigits: 0,
          //         maximumFractionDigits: 0,
          //       });
          //     ("</p>");
          //     rez += xx;
          //   });
          //   return rez;
          // },
        },
        legend: {},
        grid: {
          left: "8%",
          right: "4%",
          bottom: "10%",
          top: "7%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          name: "SALES VOLUME",
          nameTextStyle: {
            color: "#808080",
            fontWeight: "bold",
            fontFamily: "lato",
            fontSize: 15,
            padding: [25, 0, 0, 0],
          },
          nameLocation: "center",
          type: "category",
          boundaryGap: false,
          data: [
            "",
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          value: {},
        },
        yAxis: {
          name: "OUTLET NUMBER",
          nameTextStyle: {
            color: "#808080",
            fontWeight: "bold",
            fontFamily: "lato",
            fontSize: 15,
            padding: [0, 0, 30, 0],
          },
          nameLocation: "center",
          nameRotate: 90,
          type: "value",
        },
        series: [],
      };
    },
  },
  methods: {
    showTitleChip(items) {
      let title = "";
      if (this.selectedMenu === "Promotion") {
        title = items.promotion_title;
      } else {
        title = items.h_name;
      }
      return title;
    },
    labelChip(items) {
      let label = "";
      if (this.selectedMenu === "Promotion") {
        label = items.promotion_code + " [" + items.promotion_title + "]";
      } else {
        label = items.h_name;
      }
      return label;
    },
    changeTab(tab) {
      this.oldTab = this.datableTabBy;
      this.datableTabBy = tab;
      this.searchReport("changeTab");
    },
    onChangeMenu() {
      this.loadData = true;
      this.hideoverlay = true;
      this.datableTabBy = "1";
      this.oldTab = "1";
      this.filterChips = [];
      this.dataChipsProduct = [];
      this.countRowChipsProduct = 0;
      this.rowChipsProduct = 1;
      this.filterChipsSearch = [];
      this.productGroups = [];
      this.filterProductGroup = [];
      this.filterCustGroup = [];
      this.radioPromotion = "active";
      this.radioPromotionSearch = "active";

      // this.vStartDate = null;
      // this.vEndDate = null;
      let today = new Date();
      this.vStartDate = new Date(today.getFullYear(), today.getMonth(), 1);
      this.vEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      this.selectedCustomer = [];
      this.selectedSmCode = [];
      this.tbListReport = [];

      this.totalPromotion = 0;
      this.totalQty = 0;
      this.totalAmount = 0;
      this.totalNetAmount = 0;

      let date = moment(new Date());
      let year = parseInt(date.format("YYYY"));
      this.amountPeriod = {};
      this.optionsChart.legend.data = [];
      this.optionsChart.series = [];
      this.optionsChart.series[0] = {
        name: "Year [" + year + "]",
        data: "",
        type: "line",
        itemStyle: { color: this.colorChartSeries[0] },
        lineStyle: { color: this.colorChartSeries[0] },
      };

      this.optionsChart.yAxis.min = 0;
      this.optionsChart.yAxis.max = 100;
      this.$refs.lineChart.refresh();

      this.chartSummaryCustomer = 0;
      this.chartSummaryOrder = 0;
      this.totalAmount = 0;
      this.totalQty = 0;

      if (this.selectedMenu === "Promotion") {
        this.getAllPromotion();
        this.productGroups = this.dataProductGroups;
      } else {
        this.getAllVD();
        this.productGroups = this.dataProductGroupsVD;
      }
    },
    condPromotion() {
      this.filterChips = [];
      this.getAllPromotion();
    },
    customLabel({ id, label }) {
      return `${id} - ${label}`;
    },
    customLabelVD({ h_name }) {
      return `${h_name}`;
    },
    addProduct(item) {
      // console.log("item ==>", item);
      let value = this.dataChipsProduct.findIndex((items) => {
        return item.id === items.id;
      });

      if (value === -1) {
        this.rowChipsProduct =
          this.dataChipsProduct.length % 5 === 0
            ? Math.ceil(this.dataChipsProduct.length / 5) + 1
            : Math.ceil(this.dataChipsProduct.length / 5);
        this.dataChipsProduct.push({
          id: item.id,
          code_filter: item.code_filter,
          label: item.label,
          row: this.rowChipsProduct === 0 ? 1 : this.rowChipsProduct,
        });
      }

      this.countRowChipsProduct = Math.ceil(this.dataChipsProduct.length / 5);
    },
    deleteChipsProduct(items, index) {
      this.dataChipsProduct.splice(index, 1);
      let row = 1;
      for (let i = 0; i < this.dataChipsProduct.length; i++) {
        if (i !== 0 && i % 5 === 0) {
          row++;
        }
        this.dataChipsProduct[i]["row"] = row;
      }
      this.countRowChipsProduct = Math.ceil(this.dataChipsProduct.length / 5);
    },
    addCondFilter() {
      this.showFilterDialog = false;
      this.filterChips = [];
      this.filterChipsSearch = [];
      if (this.selectedMenu === "Promotion") {
        let obj = {};
        if (this.filterProductGroup.id !== undefined) {
          obj = {
            name: this.filterProductGroup.label,
            id: this.filterProductGroup.id,
            type: "productgroup",
          };
        }

        if (obj.name !== undefined) {
          this.filterChipsSearch.push(obj);
        }
        // }
        this.searchPromotion();
      } else {
        let obj = {};
        if (this.filterProductGroup.id !== undefined) {
          obj = {
            name: this.filterProductGroup.label,
            id: this.filterProductGroup.id,
            type: "productgroup",
          };
        }

        if (obj.name !== undefined) {
          this.filterChipsSearch.push(obj);
        }
        this.searchVD();
      }
    },
    searchPromotion() {
      let prodgroup = "";
      let custgroup = "";
      if (this.filterProductGroup.id !== undefined) {
        prodgroup = this.filterProductGroup.id;
      }
      if (this.filterCustGroup._id !== undefined) {
        custgroup = this.filterCustGroup._id;
      }

      let datas = { prodgroup: prodgroup, custgroup: custgroup };
      let self = this;
      self.filterChips = [];
      promotionService
        .filterPromotion(datas)
        .then((response) => {
          if (response) {
            self.filterChips = response;

            response.forEach((value, index) => {
              let key = self.optionsPromotion.findIndex(
                (item) => item.promotion_code === value.promotion_code
              );
              self.optionsPromotion.splice(key, 1);
            });
          }
        })
        .catch();
    },
    searchVD() {
      let prodgroup = "";
      if (this.filterProductGroup.id !== undefined) {
        prodgroup = this.filterProductGroup.id;
      }

      let datas = { prodgroup: prodgroup };
      let self = this;
      self.filterChips = [];
      PricingService.filterVD(datas)
        .then((response) => {
          if (response) {
            self.filterChips = response;

            response.forEach((value, index) => {
              let key = self.optionsVD.findIndex(
                (item) => item.h_name === value.h_name
              );
              self.optionsVD.splice(key, 1);
            });
          }
        })
        .catch();
    },
    handleScroll(event) {
      if (
        event.target.scrollTop + event.target.clientHeight >=
        event.target.scrollHeight
      ) {
        this.onHandleScroll();
      }
    },
    onHandleScroll() {
      // console.log("-onHandleScroll-");
      // this.dataSearch = {};
      if (!this.scrollStart.includes(this.tbListReport.length)) {
        this.scrollStart.push(this.tbListReport.length);
        this.getDataList();
      } else {
        this.loading = false;
      }
    },
    closeFilterDialog() {
      // if (this.filterChipsSearch.length == 0) {
      //     this.filterProductGroup = [];
      //     this.filterCustGroup = [];
      // }
      this.showFilterDialog = false;
    },
    countString(string) {
      // let num = 22;
      // let str_val = "";
      if (string.id !== undefined) {
        // str_val = string.id + " - " + string.name;
        return string.id;
      } else {
        // str_val = string.name;
        return string.name;
      }

      // let str = str_val.length;
      // if (str > num) {
      //   this.titleChip = true;
      //   return str_val.substr(0, num) + "...";
      // } else {
      //   this.titleChip = false;
      //   return str_val;
      // }
    },
    deleteFilterSearch(items, index) {
      this.filterChipsSearch.splice(index, 1);
      if (items.type == "productgroup") {
        this.filterProductGroup = [];
      } else if (items.type == "customergroup") {
        this.filterCustGroup = [];
      }

      if (this.selectedMenu === "Promotion") {
        if (this.filterChipsSearch.length === 0) {
          this.filterChips = [];
          this.getAllPromotion();
        } else {
          this.searchPromotion();
        }
      } else {
        if (this.filterChipsSearch.length === 0) {
          this.filterChips = [];
          this.getAllVD();
        } else {
          this.searchVD();
        }
      }
    },
    getAllProductGroup() {
      promotionService
        .getAllProductGroup()
        .then((response) => {
          if (response) {
            response.sort((a, b) => (a.id > b.id ? 1 : -1));
            this.dataProductGroups = response;
            this.productGroups = response;
          }
        })
        .catch();
    },
    getAllProductGroupVD() {
      let emp_code = this.$jwt.decode(localStorage.getItem("token")).code;
      let datas = {
        pro_code: "",
        type: "master",
        data_delete: [],
        emp_code: emp_code,
        name: "",
        group: "",
        subgroup: "",
        cg: "",
      };

      PricingService.getAllProductGroup(datas)
        .then((response) => {
          if (response.data) {
            response.data.sort((a, b) => (a.id > b.id ? 1 : -1));
            this.dataProductGroupsVD = response.data;
          }
        })
        .catch();
    },
    getAllPromotion() {
      let datas = {
        filter_promotion: this.radioPromotion,
      };
      promotionService
        .getAllPromotion(datas)
        .then((response) => {
          if (response) {
            this.optionsPromotion = response;
            this.loadData = false;
            this.hideoverlay = false;
          }
        })
        .catch();
    },
    getAllVD() {
      PricingService.getAllVD()
        .then((response) => {
          if (response) {
            response.sort((a, b) => (a.h_name > b.h_name ? 1 : -1));
            this.optionsVD = response;
            this.loadData = false;
            this.hideoverlay = false;
          }
        })
        .catch();
    },
    getAllCustomer() {
      promotionService
        .getAllCustomer()
        .then((response) => {
          if (response) {
            this.optionsCustomer = response;
          }
        })
        .catch();
    },
    getAllSmCode() {
      promotionService
        .getAllSmCode()
        .then((response) => {
          if (response) {
            this.optionsSmCode = response;
          }
        })
        .catch();
    },
    customLabelPromotion({ promotion_code, promotion_title }) {
      return `${promotion_code} [ ${promotion_title} ]`;
    },
    customLabelCustomer({ code, title_th }) {
      return `${code} - ${title_th}`;
    },
    customLabelSmCode({ code }) {
      return `${code}`;
    },
    clearAll(id, type) {
      if (type == "promotion") {
        this.selectedPromotion = [];
      } else if (type == "customer") {
        this.selectedCustomer = [];
      } else if (type == "productgroup") {
        this.filterProductGroup = [];
      } else if (type == "customergroup") {
        this.filterCustGroup = [];
      } else if (type == "sm_code") {
        this.selectedSmCode = [];
      }
    },
    clearDataLoad() {
      this.scrollStart = [0];
      this.tbListReport = [];
      // this.loadPage = 1;
      this.startPage = 0;
    },
    setDataFilter(selectedOption) {
      let obj = {};
      if (this.selectedMenu === "Promotion") {
        obj = {
          promotion_code: selectedOption.promotion_code,
          promotion_title: selectedOption.promotion_title,
        };
        this.filterChips.push(obj);

        let key = this.optionsPromotion.findIndex(
          (item) => item.promotion_code === selectedOption.promotion_code
        );
        this.optionsPromotion.splice(key, 1);
      } else {
        obj = {
          vd_id: selectedOption.vd_id,
          h_name: selectedOption.h_name,
        };
        this.filterChips.push(obj);

        let key = this.optionsVD.findIndex(
          (item) => item.h_name === selectedOption.h_name
        );
        this.optionsVD.splice(key, 1);
      }
    },
    onClosePromotion() {
      this.selectedPromotion = [];
    },
    onCloseVD() {
      this.selectedVD = [];
    },
    deleteFilter(items, index) {
      let tmpArr = [];
      for (let i = 0; i < this.filterChips.length; i++) {
        if (i != index) {
          tmpArr.push(this.filterChips[i]);
        }
      }
      this.filterChips = tmpArr;

      if (this.selectedMenu === "Promotion") {
        this.optionsPromotion.push(items);
        this.optionsPromotion.sort((a, b) =>
          a.promotion_code > b.promotion_code ? 1 : -1
        );
      } else {
        this.optionsVD.push(items);
        this.optionsVD.sort((a, b) => (a.h_name > b.h_name ? 1 : -1));
      }

      if (this.filterChips.length === 0) {
        this.filterChipsSearch = [];
        this.filterProductGroup = [];
        this.filterCustGroup = [];
      }
    },
    clearstartdate() {
      this.vStartDate = null;
    },
    clearenddate() {
      this.vEndDate = null;
    },
    searchReport(type) {
      this.$nextTick(() => {
        if (
          this.vStartDate === null ||
          this.vStartDate == "" ||
          this.vEndDate === null ||
          this.vEndDate === "" ||
          this.$refs.startdate.$el.children[2] === undefined ||
          this.$refs.enddate.$el.children[2] === undefined
        ) {
          this.dContent = "Please select Start date - End date";
          this.showSnackbar = true;
          this.loadData = false;
          this.hideoverlay = false;
          return false;
        }
        // else if (
        //   this.radioPromotion === "all" &&
        //   this.selectedMenu === "Promotion" &&
        //   this.filterChips.length === 0
        // ) {
        //   this.dContent = "Please select Promotion";
        //   this.showSnackbar = true;
        //   this.loadData = false;
        //   this.hideoverlay = false;
        //   return false;
        // }
        else {
          this.clearDataLoad();
          this.getDataList();
        }
      });
    },
    exportReport() {
      // let exp_report = this.tbListReport;
      let exp_report = this.tbListReport;
      let json_data = [];
      for (let index in exp_report) {
        let customer_name_th = exp_report[index].customer_name_th;
        if (
          exp_report[index].customer_name_th !== undefined &&
          exp_report[index].customer_name_th !== null &&
          exp_report[index].customer_name_th.indexOf(",") > -1
        ) {
          customer_name_th = '"' + exp_report[index].customer_name_th + '"';
        }

        let po_no = exp_report[index].po_no;
        if (
          exp_report[index].po_no !== undefined &&
          exp_report[index].po_no !== null &&
          exp_report[index].po_no.indexOf(",") > -1
        ) {
          po_no = '"' + exp_report[index].po_no + '"';
          // po_no = "\"" + exp_report[index].po_no + "\"";
        }

        if (this.selectedMenu === "Promotion") {
          let promo_code = exp_report[index].promo_code;
          if (
            exp_report[index].promo_code !== undefined &&
            exp_report[index].promo_code !== null &&
            exp_report[index].promo_code.indexOf(",") > -1
          ) {
            promo_code = '"' + exp_report[index].promo_code + '"';
          }

          if (this.datableTabBy === "0") {
            //TAB BY PROMOTION
            json_data.push({
              "Cust Code": exp_report[index].cust_code,
              // "Cust Name": exp_report[index].customer_name_th,
              "Cust Name":
                exp_report[index].customer_name_th === undefined ||
                exp_report[index].customer_name_th === null
                  ? ""
                  : customer_name_th,
              // "Promotion Code": exp_report[index].promo_code,
              "Promotion Code":
                exp_report[index].promo_code === undefined ||
                exp_report[index].promo_code === null
                  ? ""
                  : promo_code,
              Salesman: exp_report[index].sm_code,
              // "PO No": exp_report[index].po_no,
              "PO No":
                exp_report[index].po_no === undefined ||
                exp_report[index].po_no === null
                  ? ""
                  : po_no,
              "PO Date": exp_report[index].po_date,
              Amount: exp_report[index].sum_by_set,
              "Inv No":
                exp_report[index].inv_no === null
                  ? ""
                  : exp_report[index].inv_no,
              "Inv Amount": exp_report[index].inv_total_amount,
            });
          } else {
            //TAB BY ITEM
            let item_name = exp_report[index].item_name;
            if (
              exp_report[index].item_name !== undefined &&
              exp_report[index].item_name !== null &&
              exp_report[index].item_name.indexOf(",") > -1
            ) {
              item_name = '"' + exp_report[index].item_name + '"';
            }

            json_data.push({
              "Item Code": exp_report[index].item_code,
              "Item Name": exp_report[index].item_name,
              "Cust Code": exp_report[index].cust_code,
              // "Cust Name": exp_report[index].customer_name_th,
              "Cust Name":
                exp_report[index].customer_name_th === undefined ||
                exp_report[index].customer_name_th === null
                  ? ""
                  : customer_name_th,
              // "Promotion Code": exp_report[index].promo_code,
              "Promotion Code":
                exp_report[index].promo_code === undefined ||
                exp_report[index].promo_code === null
                  ? ""
                  : promo_code,
              Salesman: exp_report[index].sm_code,
              // "PO No": exp_report[index].po_no,
              "PO No":
                exp_report[index].po_no === undefined ||
                exp_report[index].po_no === null
                  ? ""
                  : po_no,
              "PO Date": exp_report[index].po_date,
              Amount: exp_report[index].amount,
              "Inv No":
                exp_report[index].inv_no === null
                  ? ""
                  : exp_report[index].inv_no,
              "Inv Amount": exp_report[index].inv_amount,
            });
          }
        } else {
          let h_name = exp_report[index].h_name;
          if (
            exp_report[index].h_name !== undefined &&
            exp_report[index].h_name !== null &&
            exp_report[index].h_name.indexOf(",") > -1
          ) {
            h_name = '"' + exp_report[index].h_name + '"';
          }

          json_data.push({
            "Cust Code": exp_report[index].cust_code,
            // "Cust Name": exp_report[index].customer_name_th,
            "Cust Name":
              exp_report[index].customer_name_th === undefined ||
              exp_report[index].customer_name_th === null
                ? ""
                : customer_name_th,
            "Volume Discount":
              exp_report[index].h_name === undefined ||
              exp_report[index].h_name === null
                ? ""
                : h_name,
            Salesman: exp_report[index].sm_code,
            // "PO No": exp_report[index].po_no,
            "PO No":
              exp_report[index].po_no === undefined ||
              exp_report[index].po_no === null
                ? ""
                : po_no,
            "PO Date": exp_report[index].po_date,
            Amount: exp_report[index].sum_by_set,
            "Inv No":
              exp_report[index].inv_no === null ? "" : exp_report[index].inv_no,
            "Inv Amount": exp_report[index].inv_total_amount,
          });
        }
      }

      if (json_data.length > 0) {
        if (this.selectedMenu === "Promotion") {
          this.JSONToCSVConvertor(json_data, "promotion_analysis_", true);
        } else {
          this.JSONToCSVConvertor(json_data, "volume_discount_analysis_", true);
        }
      } else {
        alert("data is null");
        return;
      }
    },
    exportReportItem(withby) {
      let startDate = "";
      let endDate = "";
      // if (this.vStartDate == null && this.vEndDate != null) {
      //   this.dContent = "Please select start date.";
      //   this.showSnackbar = true;
      //   this.loadData = false;
      //   this.hideoverlay = false;
      //   return false;
      // }
      if (
        this.vStartDate === null ||
        this.vStartDate == "" ||
        this.vEndDate === null ||
        this.vEndDate === "" ||
        this.$refs.startdate.$el.children[2] === undefined ||
        this.$refs.enddate.$el.children[2] === undefined
      ) {
        this.dContent = "Please select Start date - End date";
        this.showSnackbar = true;
        this.loadData = false;
        this.hideoverlay = false;
        return false;
      }

      if (this.vStartDate != null && this.vEndDate == null) {
        startDate = moment(this.vStartDate)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        endDate = moment(this.vStartDate)
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      } else if (this.vStartDate != null && this.vEndDate != null) {
        startDate = moment(this.vStartDate)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        endDate = moment(this.vEndDate)
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      }
      this.loadData = true;
      let datas = {};

      if (this.selectedMenu === "Promotion") {
        let promotion_code = [];
        let item_code = [];
        for (let i = 0; i < this.filterChips.length; i++) {
          promotion_code.push(this.filterChips[i].promotion_code);
        }
        for (let j = 0; j < this.dataChipsProduct.length; j++) {
          item_code.push(this.dataChipsProduct[j].id);
        }

        datas = {
          with: withby,
          items: item_code,
          promotion: promotion_code.length > 0 ? promotion_code : "",
          start_date: startDate,
          end_date: endDate,
          customer: this.selectedCustomer.code
            ? this.selectedCustomer.code
            : "",
          sm_code: this.selectedSmCode.code ? this.selectedSmCode.code : "",
          filter_promotion: this.radioPromotionSearch,
        };
      } else {
        let vd_id = [];
        let item_code = [];
        for (let i = 0; i < this.filterChips.length; i++) {
          vd_id.push(this.filterChips[i].vd_id);
        }
        for (let j = 0; j < this.dataChipsProduct.length; j++) {
          item_code.push(this.dataChipsProduct[j].id);
        }

        datas = {
          with: withby,
          items: item_code,
          voldiscount: vd_id.length > 0 ? vd_id : "",
          start_date: startDate,
          end_date: endDate,
          customer: this.selectedCustomer.code
            ? this.selectedCustomer.code
            : "",
          sm_code: this.selectedSmCode.code ? this.selectedSmCode.code : "",
          product:
            this.filterProductGroup.id !== undefined
              ? this.filterProductGroup.id
              : "",
          filter_promotion: this.radioPromotionSearch,
        };
      }

      if (
        datas.promotion != "" ||
        datas.start_date != "" ||
        datas.end_date != "" ||
        datas.customer != ""
      ) {
        let self = this;
        if (this.selectedMenu === "Promotion") {
          promotionService
            .ReportExportItem(datas)
            .then((response) => {
              console.log("response ==>", response);
              let json_data = response;
              //                    if (this.selectedMenu === "Promotion") {
              //
              //                    }else{
              //
              //                    }
              if (json_data.length > 0) {
                if (withby === "item") {
                  self.JSONToCSVConvertor(
                    json_data,
                    "promotion_by_item_",
                    true
                  );
                } else {
                  self.JSONToCSVConvertor(
                    json_data,
                    "promotion_analysis_",
                    true
                  );
                }
              } else {
                // alert("data is null.");
                this.dContent = "Data is null.";
                this.showSnackbar = true;
                this.loadData = false;
                this.hideoverlay = false;
                return false;
              }
              this.loadData = false;
            })
            .catch();
        } else {
          PricingService.ReportExportItem(datas)
            .then((response) => {
              let json_data = response;

              if (json_data.length > 0) {
                if (withby === "item") {
                  self.JSONToCSVConvertor(
                    json_data,
                    "volume_discount_by_item_",
                    true
                  );
                } else {
                  self.JSONToCSVConvertor(
                    json_data,
                    "volume_discount_analysis_",
                    true
                  );
                }
              } else {
                // alert("data is null..");
                this.dContent = "Data is null.";
                this.showSnackbar = true;
                this.loadData = false;
                this.hideoverlay = false;
                return false;
              }
              this.loadData = false;
            })
            .catch();
        }
      } else {
        this.loadData = false;
      }
    },
    JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
      var arrData =
        typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
      var CSV = "";
      let last_column = "";
      if (ShowLabel) {
        var row = "";
        for (var index in arrData[0]) {
          row += index + ",";
          last_column = index;
        }

        row = row.slice(0, -1);
        CSV += row + "\r\n";
      }

      for (var i = 0; i < arrData.length; i++) {
        let row = "";
        for (let index in arrData[i]) {
          if (index != last_column) {
            row += arrData[i][index] + ",";
          } else {
            row += arrData[i][index];
          }
        }

        row.slice(0, row.length - 1);
        CSV += row + "\r\n";
      }

      if (CSV == "") {
        alert("Invalid data");
        return;
      }

      var d = new Date();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var currentDate =
        d.getFullYear() +
        (month < 10 ? "0" : "") +
        month +
        (day < 10 ? "0" : "") +
        day;

      var fileName = ReportTitle + currentDate;
      //      var universalBOM = "\uFEFF";
      //      var uri = "data:text/csv;charset=utf-8," + encodeURIComponent(universalBOM+CSV);
      var uri = "data:text/csv;charset=utf-8," + encodeURIComponent(CSV);
      var link = document.createElement("a");
      link.href = uri;
      link.style = "visibility:hidden";
      link.download = fileName + ".csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    formatDate(date) {
      // return moment(date).format("YYYY-MM-DD HH:mm:ss");
      // return moment(date).format("YYYY-MM-DD");
      return moment(date).format("DD-MM-YYYY");
    },
    formatNumber(value, dicimal) {
      if (isNaN(parseFloat(value))) {
        let val = 0;
        return val.toFixed(dicimal);
        // return value;
      } else {
        if (value % 1 == 0) {
          return parseFloat(value).toLocaleString(undefined, {
            minimumFractionDigits: dicimal,
            maximumFractionDigits: dicimal,
          });
        } else {
          if (typeof value === "number") {
            return parseFloat(value).toLocaleString(undefined, {
              minimumFractionDigits: dicimal,
              maximumFractionDigits: dicimal,
            });
          } else {
            let parts = value.toString().split(".");
            let num = (parts[0] = parts[0].replace(
              /\B(?=(\d{3})+(?!\d))/g,
              ","
            ));
            let digit = parts[1].slice(0, 3);
            digit = digit.length < 2 ? digit + "0" : digit;
            let rs = num + "." + digit;
            let comma = parseFloat(rs.replace(",", ""));
            // return Math.round(parseFloat(comma) * 100) / 100;
            return parseFloat(
              Math.round(parseFloat(comma) * 100) / 100
            ).toLocaleString(undefined, {
              minimumFractionDigits: dicimal,
              maximumFractionDigits: dicimal,
            });
          }
        }
      }
    },
    getDataList(type) {
      this.loadData = true;
      this.hideoverlay = true;
      // let arrList = [];
      let sumOfSet = 0;
      let sumInvAmount = 0;
      // let promoCode = "";
      // let self = this;
      // let currentDate = moment(),
      //   //currentYear = parseInt(currentDate.format('YYYY')),
      //   //year_series = [],
      //   //numberOfYear = 3,
      //   seriesOfYear = {},
      //   chartData = {},
      //   sumCustomer = 0,
      //   // sumOrder = 0,
      //   sumAmount = 0,
      //   sumNetAmount = 0,
      //   customerAll = [],
      //   PoAll = [],
      //   PromoAll = [],
      //   VDAll = [],
      //   netAmountAll = 0,
      //   customerPeriod = {},
      //   AmountPeriod = {};
      /*do {
                year_series[--numberOfYear] = currentYear
                chartData[numberOfYear] = {
                    name: 'Year [' + currentYear + ']',
                    data: ['', 0, 0, 0, 0, 0 ,0 ,0 ,0 ,0 ,0, 0, 0]
                }
                customerPeriod[numberOfYear] = []
                currentYear--
            } while (numberOfYear > 0)*/

      /* START SEARCH */
      let startDate = "";
      let endDate = "";
      if (this.vStartDate == null && this.vEndDate != null) {
        this.dContent = "Please select start date.";
        this.showSnackbar = true;
        this.loadData = false;
        this.hideoverlay = false;
        return false;
      }
      if (this.vStartDate != null && this.vEndDate == null) {
        startDate = moment(this.vStartDate)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        endDate = moment(this.vStartDate)
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      } else if (this.vStartDate != null && this.vEndDate != null) {
        startDate = moment(this.vStartDate)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        endDate = moment(this.vEndDate)
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      }

      /* check range date within one month */
      // if (this.checkedAllPromotion || this.radioPromotion === "all") {
      if (
        (this.selectedMenu === "Volume Discount" &&
          // this.checkedAllPromotion &&
          this.dataChipsProduct.length == 0 &&
          this.filterChips.length == 0 &&
          this.selectedCustomer.code === undefined &&
          this.selectedSmCode.code === undefined) ||
        (this.radioPromotion === "all" &&
          this.dataChipsProduct.length == 0 &&
          this.filterChips.length == 0 &&
          this.selectedCustomer.code === undefined &&
          this.selectedSmCode.code === undefined) ||
        this.dataChipsProduct.length > 5
      ) {
        let data_range = 0;
        let start = new Date(startDate);
        let end = new Date(endDate);
        while (start < end) {
          data_range++;
          let newDate = start.setDate(start.getDate() + 1);
          start = new Date(newDate);
        }
        if (data_range > 31) {
          this.dContent = "Please select date range within 1 month.";
          this.showSnackbar = true;
          this.loadData = false;
          this.hideoverlay = false;
          return false;
        }
        // this.filterChips = [];
      }
      /* end cal range date */

      let datas = {};

      if (this.selectedMenu === "Promotion") {
        let promotion_code = [];
        let item_code = [];
        for (let i = 0; i < this.filterChips.length; i++) {
          promotion_code.push(this.filterChips[i].promotion_code);
        }
        for (let j = 0; j < this.dataChipsProduct.length; j++) {
          item_code.push(this.dataChipsProduct[j].id);
        }

        datas = {
          promotion: promotion_code.length > 0 ? promotion_code : "",
          start_date: startDate,
          end_date: endDate,
          customer: this.selectedCustomer.code
            ? this.selectedCustomer.code
            : "",
          sm_code: this.selectedSmCode.code ? this.selectedSmCode.code : "",
          items: item_code,
          filter_promotion: this.radioPromotion,
          type: this.datableTabBy == 0 ? "summary" : "po",
          // page: type !== undefined && type === "all" ? 1 : this.loadPage,
          start: type !== undefined && type === "all" ? 0 : this.startPage,
          limit: type !== undefined && type === "all" ? 99999 : 25,
        };
      } else {
        let vd_id = [];
        let item_code = [];
        for (let i = 0; i < this.filterChips.length; i++) {
          vd_id.push(this.filterChips[i].vd_id);
        }
        for (let j = 0; j < this.dataChipsProduct.length; j++) {
          item_code.push(this.dataChipsProduct[j].id);
        }

        datas = {
          voldiscount: vd_id.length > 0 ? vd_id : "",
          start_date: startDate,
          end_date: endDate,
          customer: this.selectedCustomer.code
            ? this.selectedCustomer.code
            : "",
          sm_code: this.selectedSmCode.code ? this.selectedSmCode.code : "",
          product:
            this.filterProductGroup.id !== undefined
              ? this.filterProductGroup.id
              : "",
          items: item_code,
          filter_promotion: this.checkedAllPromotion === true ? "all" : "",
          type: this.datableTabBy == 0 ? "summary" : "po",
          // page: type !== undefined && type === "all" ? 1 : this.loadPage,
          start: type !== undefined && type === "all" ? 0 : this.startPage,
          limit: type !== undefined && type === "all" ? 99999 : 25,
        };
        // console.log("checkedAllPromotion ==>", this.checkedAllPromotion);
        // console.log("datas ==>", datas);
      }

      if (type !== undefined && type === "all") {
        this.tbListReport = [];
      }

      this.radioPromotionSearch = this.radioPromotion;

      /* END SEARCH */

      // this.totalAmount = 0;
      // this.totalNetAmount = 0;
      // this.totalPromotion = 0;
      if (
        datas.promotion != "" ||
        datas.start_date != "" ||
        datas.end_date != "" ||
        datas.customer != ""
      ) {
        if (this.selectedMenu === "Promotion") {
          promotionService
            .ReportList(datas)
            .then((response) => {
              if (response.length > 0) {
                let no = this.tbListReport.length;
                for (let i = 0; i < response.length; i++) {
                  no++;

                  if (this.datableTabBy == 1) {
                    sumOfSet = 0;
                    sumInvAmount = 0;
                    // for (let j = 0; j < response[i].trn_order.length; j++) {
                    //   sumOfSet += response[i].trn_order[j].amount
                    //     ? parseFloat(response[i].trn_order[j].amount)
                    //     : 0;

                    //   sumInvAmount += response[i].trn_order[j].inv_total_amount
                    //     ? parseFloat(response[i].trn_order[j].inv_total_amount)
                    //     : 0;
                    // }
                    for (let j = 0; j < response[i].order.length; j++) {
                      sumOfSet += response[i].order[j].amount
                        ? parseFloat(response[i].order[j].amount)
                        : 0;

                      sumInvAmount += response[i].order[j].inv_total_amount
                        ? parseFloat(response[i].order[j].inv_total_amount)
                        : 0;
                    }

                    this.tbListReport.push({
                      // no: i + 1,
                      no: no,
                      cust_code: response[i].cust_code,
                      customer_name_th: response[i].customer_name_th,
                      po_date: response[i].po_date,
                      sm_code: response[i].sm_code,
                      po_no: response[i].po_no,
                      inv_no: response[i].inv_no,
                      promo_code: response[i].promo_code,
                      sum_by_set: sumOfSet.toFixed(2),
                      inv_total_amount: sumInvAmount.toFixed(2),
                    });
                  } else {
                    this.tbListReport.push({
                      no: no,
                      promo_code: response[i].promo_code,
                      sum_customer: response[i].customer,
                      sum_po: response[i].po,
                      amount: response[i].amount,
                      inv_total_amount: response[i].inv_total_amount,
                    });
                  }

                  // self.totalAmount += sumOfSet ? parseFloat(sumOfSet) : 0;
                  // self.totalNetAmount += sumInvAmount
                  //   ? parseFloat(sumInvAmount)
                  //   : 0;
                }
                // this.loadPage++;
                this.startPage = this.startPage + response.length;
              } else if (this.tbListReport.length === 0) {
                this.clearDataLoad();
              }
              if (datas.start !== 0) {
                this.loadData = false;
                this.hideoverlay = false;
              }
            })
            .catch();

          if (datas.start === 0) {
            promotionService
              .ReportChart(datas)
              .then((response) => {
                // console.log("response ==>", response);
                if (response.chart.length > 0) {
                  this.optionsChart["series"] = response.chart;
                  // let amountrow = [];
                  // let amountObj = {};
                  // let objRes = Object.keys(response.chart_total);
                  // for (let k_year = 0; k_year < objRes.length; k_year++) {
                  //   // console.log("==>",objRes[k_year]);
                  //   for (let i = 0; i < 12; i++) {
                  //     if (
                  //       response.chart_total[objRes[k_year]][i] !== null &&
                  //       response.chart_total[objRes[k_year]][i] !== undefined
                  //     ) {
                  //       amountrow[i] = parseFloat(
                  //         response.chart_total[objRes[k_year]][i]
                  //       );
                  //     }
                  //   }
                  //   amountObj[objRes[k_year]] = amountrow;
                  // }
                  this.amountPeriod = response.chart_total;
                  // this.amountPeriod = amountObj;
                  // this.optionsChart.tooltip.formatter = response.chart_total;
                  // console.log("this.amountPeriod ==>", this.amountPeriod);

                  // this.optionsChart.legend.data = [];
                  // this.optionsChart.series = [];
                  // Object.keys(response.chart).forEach((series, index) => {
                  //   this.optionsChart.legend.data.push(series.name);
                  //   this.optionsChart.series[index] = {
                  //     data: response.chart[series].data,
                  //     name: response.chart[series].name,
                  //     type: "line",
                  //     itemStyle: { color: this.colorChartSeries[index] },
                  //     lineStyle: { color: this.colorChartSeries[index] },
                  //   };
                  // });

                  // delete this.optionsChart.yAxis.min;
                  // delete this.optionsChart.yAxis.max;
                  this.optionsChart.yAxis.max = null;
                  this.optionsChart.tooltip.formatter = (params) => {
                    var colorSpan = (color) =>
                      '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' +
                      color +
                      '"></span>';

                    let rez = "";
                    for (let i = 0; i < params.length; i++) {
                      // let rez = '<p>' + params[0].axisValue + '</p>';
                      if (rez === "") {
                        rez = params[i].axisValue + "<br>";
                      }
                      // console.log(params); //quite useful for debug
                      let year = params[i].seriesName.substring(6, 10);
                      // console.log(
                      //   "params ==>",
                      //   params[i],
                      //   params[i].seriesName,
                      //   year
                      // );
                      let arrMonth = [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec",
                      ];
                      let month =
                        arrMonth.findIndex((item) => item === params[i].name) +
                        1;
                      // console.log("year,month ==>", year, month);
                      // let amount = amountPeriod[year][month]
                      //   ? amountPeriod[year][month]
                      //   : 0;
                      let amount =
                        this.amountPeriod !== undefined
                          ? this.amountPeriod[year][month]
                          : 0;
                      // console.log("amount ==>", amount);
                      // let amount = 0;

                      // params.forEach((item) => {
                      // console.log(item); //quite useful for debug
                      // var xx = '<p>'   + colorSpan(item.color) + ' ' + item.seriesName + ': ' + item.data + '%' + '</p>'
                      var xx =
                        "</p>" +
                        colorSpan(params[i].color) +
                        " " +
                        params[i].seriesName +
                        " : " +
                        params[i].data +
                        " - Amount : " +
                        // amount.toLocaleString(undefined, {
                        //   minimumFractionDigits: 0,
                        //   maximumFractionDigits: 0,
                        // });
                        this.formatNumber(parseFloat(amount), 2) +
                        "</p>";
                      rez += xx;
                      // });
                    }
                    return rez;
                  };

                  this.chartSummaryCustomer = parseFloat(
                    response.total_customer
                  );
                  this.chartSummaryOrder = parseFloat(response.total_order);
                  this.totalAmount = parseFloat(response.total_amount);
                  this.totalQty = parseFloat(response.total_qty);
                  this.totalPromotion = parseFloat(response.total_promotion);
                  this.totalNetAmount = parseFloat(response.total_netamount);
                } else {
                  this.optionsChart.series = [];
                  this.optionsChart.yAxis.min = 0;
                  this.optionsChart.yAxis.max = 100;

                  this.chartSummaryCustomer = 0;
                  this.chartSummaryOrder = 0;
                  this.totalAmount = 0;
                  this.totalQty = 0;
                  this.totalPromotion = 0;
                  this.totalNetAmount = 0;
                }
                this.$refs.lineChart.refresh();
                // console.log("this.optionsChart ==>", this.optionsChart);
                this.loadData = false;
                this.hideoverlay = false;
              })
              .catch();
          }
          // promotionService
          //   .ReportList(datas)
          //   .then((response) => {
          //     if (response.length > 0) {
          //       for (let i = 0; i < response.length; i++) {
          //         if (response[i].cust_code !== undefined) {
          //           if (customerAll.indexOf(response[i].cust_code) === -1) {
          //             customerAll.push(response[i].cust_code);
          //           }
          //         }
          //         if (response[i].po_no !== undefined) {
          //           if (PoAll.indexOf(response[i].po_no) === -1) {
          //             PoAll.push(response[i].po_no);
          //           }
          //         }
          //         if (response[i].promo_code !== undefined) {
          //           if (PromoAll.indexOf(response[i].promo_code) === -1) {
          //             PromoAll.push(response[i].promo_code);
          //           }
          //         }
          //         if (
          //           response[i].inv_no !== undefined &&
          //           response[i].inv_no !== null &&
          //           response[i].inv_no !== "" &&
          //           response[i].inv_no !== 0
          //         ) {
          //           netAmountAll++;
          //           if (response[i].inv_total_amount !== undefined) {
          //             sumNetAmount += response[i].inv_total_amount
          //               ? parseFloat(response[i].inv_total_amount)
          //               : 0;
          //           }
          //         }

          //         // sumOrder++;
          //         if (response[i].po_date !== undefined) {
          //           let poDate = moment(new Date(response[i].po_date));
          //           let year = parseInt(poDate.format("YYYY"));
          //           if (chartData[year] === undefined) {
          //             chartData[year] = {
          //               name: "Year [" + year + "]",
          //               data: ["", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          //             };

          //             customerPeriod[year] = [];
          //             AmountPeriod[year] = [];
          //           }
          //           //let series = year_series.indexOf(parseInt(poDate.format('YYYY')));
          //           let series = year;
          //           let period_mount = parseInt(poDate.format("M"));
          //           if (customerPeriod[series][period_mount] === undefined) {
          //             customerPeriod[series][period_mount] = [
          //               response[i].cust_code,
          //             ];
          //           } else if (
          //             customerPeriod[series][period_mount].indexOf(
          //               response[i].cust_code
          //             ) === -1
          //           ) {
          //             customerPeriod[series][period_mount].push(
          //               response[i].cust_code
          //             );
          //           }

          //           let invAmount = 0;
          //           if (AmountPeriod[series][period_mount] === undefined) {
          //             for (let j = 0; j < response[i].trn_order.length; j++) {
          //               invAmount += response[i].trn_order[j].amount
          //                 ? parseFloat(response[i].trn_order[j].amount)
          //                 : 0;
          //             }
          //             AmountPeriod[series][period_mount] = invAmount;
          //           } else {
          //             for (let j = 0; j < response[i].trn_order.length; j++) {
          //               invAmount += response[i].trn_order[j].amount
          //                 ? parseFloat(response[i].trn_order[j].amount)
          //                 : 0;
          //             }
          //             AmountPeriod[series][period_mount] += invAmount;
          //           }
          //         }

          //         this.amountPeriod = AmountPeriod;

          //         sumOfSet = 0;
          //         sumInvAmount = 0;
          //         // promoCode = "";
          //         for (let j = 0; j < response[i].trn_order.length; j++) {
          //           sumOfSet += response[i].trn_order[j].amount
          //             ? parseFloat(response[i].trn_order[j].amount)
          //             : 0;

          //           sumInvAmount += response[i].trn_order[j].inv_total_amount
          //             ? parseFloat(response[i].trn_order[j].inv_total_amount)
          //             : 0;
          //           // promoCode = response[i].trn_order[j].promo_code ?
          //           //     response[i].trn_order[j].promo_code :
          //           //     "";
          //         }
          //         // sumAmount += sumOfSet

          //         // self.totalAmount += response[i].total_amount ? parseFloat(response[i].total_amount) : 0;
          //         // self.totalNetAmount += response[i].inv_total_amount ? parseFloat(response[i].inv_total_amount) : 0;
          //         self.totalAmount += sumOfSet ? parseFloat(sumOfSet) : 0;
          //         self.totalNetAmount += sumInvAmount
          //           ? parseFloat(sumInvAmount)
          //           : 0;

          //         arrList.push({
          //           no: i + 1,
          //           cust_code: response[i].cust_code,
          //           customer_name_th: response[i].customer_name_th,
          //           po_date: response[i].po_date,
          //           sm_code: response[i].sm_code,
          //           po_no: response[i].po_no,
          //           inv_no: response[i].inv_no,
          //           promo_code: response[i].promo_code,
          //           // promo_code: promoCode,
          //           sum_by_set: sumOfSet.toFixed(2),
          //           // sum_by_set: response[i].total_amount,
          //           // sum_by_set: response[i].amount,
          //           // inv_total_amount: response[i].inv_total_amount
          //           inv_total_amount: sumInvAmount.toFixed(2),
          //         });
          //       }

          //       self.tbListReport = arrList;
          //       /* set Graph Line */
          //       // console.log("customerPeriod ==>", customerPeriod);
          //       let ymax = 0;
          //       Object.keys(customerPeriod).forEach((series) => {
          //         customerPeriod[series].forEach((period, index) => {
          //           if (period.length > ymax) {
          //             ymax = period.length;
          //           }
          //           chartData[series].data[index] = period.length;
          //         });
          //       });

          //       this.optionsChart.legend.data = [];
          //       this.optionsChart.series = [];
          //       Object.keys(chartData).forEach((series, index) => {
          //         this.optionsChart.legend.data.push(series.name);
          //         this.optionsChart.series[index] = {
          //           data: chartData[series].data,
          //           name: chartData[series].name,
          //           type: "line",
          //           itemStyle: { color: this.colorChartSeries[index] },
          //           lineStyle: { color: this.colorChartSeries[index] },
          //         };
          //       });
          //       // delete this.optionsChart.yAxis.min;
          //       // delete this.optionsChart.yAxis.max;

          //       if (response.length > 1) {
          //         this.optionsChart.yAxis.max = null;
          //       } else {
          //         this.optionsChart.yAxis.min = 0;
          //         this.optionsChart.yAxis.max = 100;
          //       }
          //       console.log("this.optionsChart ==>", this.optionsChart);

          //       /*this.optionsChart.legend.data = [chartData[0].name, chartData[1].name, chartData[2].name]
          //                 this.optionsChart.series[0].data = chartData[0].data;
          //                 this.optionsChart.series[1].data = chartData[1].data;
          //                 this.optionsChart.series[2].data = chartData[2].data;
          //                 this.optionsChart.series[0].name = chartData[0].name;
          //                 this.optionsChart.series[1].name = chartData[1].name;
          //                 this.optionsChart.series[2].name = chartData[2].name;*/
          //       // this.chartSummaryOrder = sumOrder;
          //       this.chartSummaryCustomer = customerAll.length;
          //       this.chartSummaryOrder = PoAll.length;
          //       this.totalPromotion = PromoAll.length;
          //       // this.chartSummaryAmount = sumAmount.toLocaleString(undefined, {
          //       //     minimumFractionDigits: 2,
          //       //     maximumFractionDigits: 2
          //       // });
          //       this.chartSummaryNetAmount = sumNetAmount.toLocaleString(
          //         undefined,
          //         {
          //           minimumFractionDigits: 2,
          //           maximumFractionDigits: 2,
          //         }
          //       );
          //       this.chartNetAmountLine = netAmountAll;
          //       this.$refs.lineChart.refresh();
          //       this.loadData = false;
          //       this.loadPage++;
          //     } else {
          //       this.clearDataLoad();
          //       this.loadData = false;
          //     }
          //   })
          //   .catch();
        } else {
          PricingService.ReportList(datas)
            .then((response) => {
              if (response.length > 0) {
                let no = this.tbListReport.length;
                for (let i = 0; i < response.length; i++) {
                  no++;

                  if (this.datableTabBy == 1) {
                    sumOfSet = 0;
                    sumInvAmount = 0;
                    // for (let j = 0; j < response[i].trn_order.length; j++) {
                    //   sumOfSet += response[i].trn_order[j].amount
                    //     ? parseFloat(response[i].trn_order[j].amount)
                    //     : 0;

                    //   sumInvAmount += response[i].trn_order[j].inv_total_amount
                    //     ? parseFloat(response[i].trn_order[j].inv_total_amount)
                    //     : 0;
                    // }
                    for (let j = 0; j < response[i].order.length; j++) {
                      sumOfSet += response[i].order[j].amount
                        ? parseFloat(response[i].order[j].amount)
                        : 0;

                      sumInvAmount += response[i].order[j].inv_total_amount
                        ? parseFloat(response[i].order[j].inv_total_amount)
                        : 0;
                    }

                    this.tbListReport.push({
                      no: no,
                      cust_code: response[i].cust_code,
                      customer_name_th: response[i].customer_name_th,
                      po_date: response[i].po_date,
                      sm_code: response[i].sm_code,
                      po_no: response[i].po_no,
                      inv_no: response[i].inv_no,
                      h_name: response[i].h_name,
                      sum_by_set: sumOfSet.toFixed(2),
                      inv_total_amount: sumInvAmount.toFixed(2),
                    });
                  } else {
                    this.tbListReport.push({
                      no: no,
                      promo_code: response[i].promo_code,
                      sum_customer: response[i].customer,
                      sum_po: response[i].po,
                      amount: response[i].amount,
                      inv_total_amount: response[i].inv_total_amount,
                    });
                  }
                }
                // this.loadPage++;
                this.startPage = this.startPage + response.length;
              } else if (this.tbListReport.length === 0) {
                this.clearDataLoad();
              }
              if (datas.start !== 0) {
                this.loadData = false;
                this.hideoverlay = false;
              }
            })
            .catch();

          if (datas.start === 0) {
            PricingService.ReportChart(datas)
              .then((response) => {
                if (response.chart.length > 0) {
                  this.optionsChart["series"] = response.chart;
                  this.optionsChart.yAxis.max = null;

                  this.amountPeriod = response.chart_total;
                  this.optionsChart.tooltip.formatter = (params) => {
                    var colorSpan = (color) =>
                      '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' +
                      color +
                      '"></span>';

                    let rez = "";
                    for (let i = 0; i < params.length; i++) {
                      if (rez === "") {
                        rez = params[i].axisValue + "<br>";
                      }
                      let year = params[i].seriesName.substring(6, 10);
                      let arrMonth = [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec",
                      ];
                      let month =
                        arrMonth.findIndex((item) => item === params[i].name) +
                        1;
                      let amount =
                        this.amountPeriod !== undefined
                          ? this.amountPeriod[year][month]
                          : 0;
                      var xx =
                        "</p>" +
                        colorSpan(params[i].color) +
                        " " +
                        params[i].seriesName +
                        " : " +
                        params[i].data +
                        " - Amount : " +
                        this.formatNumber(parseFloat(amount), 2) +
                        "</p>";
                      rez += xx;
                    }
                    return rez;
                  };

                  this.chartSummaryCustomer = parseFloat(
                    response.total_customer
                  );
                  this.chartSummaryOrder = parseFloat(response.total_order);
                  this.totalAmount = parseFloat(response.total_amount);
                  this.totalQty = parseFloat(response.total_qty);
                  this.totalPromotion = parseFloat(response.total_promotion);
                  this.totalNetAmount = parseFloat(response.total_netamount);
                  this.totalVD = parseFloat(response.total_vd);
                } else {
                  this.optionsChart.series = [];
                  this.optionsChart.yAxis.min = 0;
                  this.optionsChart.yAxis.max = 100;

                  this.chartSummaryCustomer = 0;
                  this.chartSummaryOrder = 0;
                  this.totalAmount = 0;
                  this.totalQty = 0;
                  this.totalPromotion = 0;
                  this.totalNetAmount = 0;
                  this.totalVD = 0;
                }
                this.$refs.lineChart.refresh();
                this.loadData = false;
                this.hideoverlay = false;
              })
              .catch();
          }
          // PricingService.ReportList(datas)
          //   .then((response) => {
          //     if (response.length > 0) {
          //       for (let i = 0; i < response.length; i++) {
          //         if (response[i].cust_code !== undefined) {
          //           if (customerAll.indexOf(response[i].cust_code) === -1) {
          //             customerAll.push(response[i].cust_code);
          //           }
          //         }
          //         if (response[i].po_no !== undefined) {
          //           if (PoAll.indexOf(response[i].po_no) === -1) {
          //             PoAll.push(response[i].po_no);
          //           }
          //         }
          //         if (
          //           response[i].h_name !== undefined &&
          //           response[i].h_name !== ""
          //         ) {
          //           if (VDAll.indexOf(response[i].h_name) === -1) {
          //             VDAll.push(response[i].h_name);
          //           }
          //         }
          //         if (
          //           response[i].inv_no !== undefined &&
          //           response[i].inv_no !== null &&
          //           response[i].inv_no !== "" &&
          //           response[i].inv_no !== 0
          //         ) {
          //           netAmountAll++;
          //           if (response[i].inv_total_amount !== undefined) {
          //             sumNetAmount += response[i].inv_total_amount
          //               ? parseFloat(response[i].inv_total_amount)
          //               : 0;
          //           }
          //         }

          //         if (response[i].po_date !== undefined) {
          //           let poDate = moment(new Date(response[i].po_date));
          //           let year = parseInt(poDate.format("YYYY"));
          //           if (chartData[year] === undefined) {
          //             chartData[year] = {
          //               name: "Year [" + year + "]",
          //               data: ["", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          //             };

          //             customerPeriod[year] = [];
          //             AmountPeriod[year] = [];
          //           }

          //           let series = year;
          //           let period_mount = parseInt(poDate.format("M"));
          //           if (customerPeriod[series][period_mount] === undefined) {
          //             customerPeriod[series][period_mount] = [
          //               response[i].cust_code,
          //             ];
          //           } else if (
          //             customerPeriod[series][period_mount].indexOf(
          //               response[i].cust_code
          //             ) === -1
          //           ) {
          //             customerPeriod[series][period_mount].push(
          //               response[i].cust_code
          //             );
          //           }

          //           let invAmount = 0;
          //           if (AmountPeriod[series][period_mount] === undefined) {
          //             for (let j = 0; j < response[i].trn_order.length; j++) {
          //               invAmount += response[i].trn_order[j].amount
          //                 ? parseFloat(response[i].trn_order[j].amount)
          //                 : 0;
          //             }
          //             AmountPeriod[series][period_mount] = invAmount;
          //           } else {
          //             for (let j = 0; j < response[i].trn_order.length; j++) {
          //               invAmount += response[i].trn_order[j].amount
          //                 ? parseFloat(response[i].trn_order[j].amount)
          //                 : 0;
          //             }
          //             AmountPeriod[series][period_mount] += invAmount;
          //           }
          //         }

          //         this.amountPeriod = AmountPeriod;

          //         sumOfSet = 0;
          //         sumInvAmount = 0;
          //         for (let j = 0; j < response[i].trn_order.length; j++) {
          //           sumOfSet += response[i].trn_order[j].amount
          //             ? parseFloat(response[i].trn_order[j].amount)
          //             : 0;
          //           sumInvAmount += response[i].trn_order[j].inv_total_amount
          //             ? parseFloat(response[i].trn_order[j].inv_total_amount)
          //             : 0;
          //         }

          //         self.totalAmount += sumOfSet ? parseFloat(sumOfSet) : 0;
          //         self.totalNetAmount += sumInvAmount
          //           ? parseFloat(sumInvAmount)
          //           : 0;

          //         arrList.push({
          //           no: i + 1,
          //           cust_code: response[i].cust_code,
          //           customer_name_th: response[i].customer_name_th,
          //           po_date: response[i].po_date,
          //           sm_code: response[i].sm_code,
          //           po_no: response[i].po_no,
          //           inv_no: response[i].inv_no,
          //           h_name: response[i].h_name,
          //           sum_by_set: sumOfSet.toFixed(2),
          //           inv_total_amount: sumInvAmount.toFixed(2),
          //         });
          //       }

          //       self.tbListReport = arrList;
          //       /* set Graph Line */
          //       let ymax = 0;
          //       Object.keys(customerPeriod).forEach((series) => {
          //         customerPeriod[series].forEach((period, index) => {
          //           if (period.length > ymax) {
          //             ymax = period.length;
          //           }
          //           chartData[series].data[index] = period.length;
          //         });
          //       });

          //       this.optionsChart.legend.data = [];
          //       this.optionsChart.series = [];
          //       Object.keys(chartData).forEach((series, index) => {
          //         this.optionsChart.legend.data.push(series.name);
          //         this.optionsChart.series[index] = {
          //           data: chartData[series].data,
          //           name: chartData[series].name,
          //           type: "line",
          //           itemStyle: { color: this.colorChartSeries[index] },
          //           lineStyle: { color: this.colorChartSeries[index] },
          //         };
          //       });

          //       if (response.length > 1) {
          //         this.optionsChart.yAxis.max = null;
          //       } else {
          //         this.optionsChart.yAxis.min = 0;
          //         this.optionsChart.yAxis.max = 100;
          //       }

          //       this.chartSummaryCustomer = customerAll.length;
          //       this.chartSummaryOrder = PoAll.length;
          //       this.totalVD = VDAll.length;
          //       this.chartSummaryNetAmount = sumNetAmount.toLocaleString(
          //         undefined,
          //         {
          //           minimumFractionDigits: 2,
          //           maximumFractionDigits: 2,
          //         }
          //       );
          //       this.chartNetAmountLine = netAmountAll;
          //       this.$refs.lineChart.refresh();
          //       this.loadData = false;
          //       this.hideoverlay = false;
          //       this.loadPage++;
          //     } else {
          //       this.clearDataLoad();
          //       this.loadData = false;
          //       this.hideoverlay = false;
          //     }
          //   })
          //   .catch();
        }
      } else {
        this.optionsChart.yAxis.min = 0;
        this.optionsChart.yAxis.max = 100;
        this.loadData = false;
        this.hideoverlay = false;
      }
    },
  },
};
</script>

<style lang="scss">
#promo-report-page {
  background-color: #fff;
  padding: 20px 20px;
  font-family: lato;
  height: 100vh;
  overflow-y: auto;
  font-weight: 400;

  .head-page {
    display: flex;

    .-title {
      padding-top: 10px;
      padding-left: 20px !important;
      font-size: 18px;
      font-weight: bold;
      color: #797979;
    }

    .-filter {
      margin-left: 20px;

      .md-field.box > .md-input.md-select-value,
      .md-field.box > .md-menu.md-select {
        height: 36px;
      }

      .md-field.md-field.box {
        margin-top: unset;
        margin-bottom: unset;
        padding: unset;
      }

      .md-field:after,
      .md-field:before {
        left: unset;
      }

      .md-field.box .md-input.md-input.md-select-value,
      .md-field.box label {
        font-size: 14px;
        padding-left: 12px;
      }

      .md-field.box > .md-menu.md-select {
        overflow: unset;
      }

      .md-field.box .md-select {
        background-color: #efefef;
        border-radius: 3px;
      }
    }
  }

  // .md-button.add-filter .md-ripple {
  //   padding-right: 15px;
  // }

  .md-layout-item {
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #797979;
    }

    &.chart,
    &.list-data {
      padding: 20px;

      .sub-title {
        font-size: 16px;
        font-weight: bold;
        color: #797979;
      }

      .custom-tab {
        text-align: center;
        padding: 15px 15px 10px 15px;
        cursor: pointer;
      }
      .sub-title-tab {
        font-size: 14px;
        font-weight: bold;
        color: #797979;
      }
    }

    &.list-data {
      padding-bottom: 0px;
    }

    &.table-data {
      padding: 8px 15px 20px 15px;
    }

    .-detail {
      margin: 25px 20px 20px 20px;

      .circle-2017 {
        width: 8px;
        height: 8px;
        border-radius: 50px;
        margin: auto;
        background-color: #32bbda;
      }

      .circle-2018 {
        width: 8px;
        height: 8px;
        border-radius: 50px;
        margin: auto;
        background-color: #8fb93e;
      }

      .circle-2019 {
        width: 8px;
        height: 8px;
        border-radius: 50px;
        margin: auto;
        background-color: #e61a8b;
      }

      .-series {
        width: 90%;
      }
    }

    .filter-chips {
      margin-top: 2px;
      // margin-top: 5px;
      // margin-bottom: 20px;
      // margin-left: 10px;

      .tab-chip {
        padding-left: 10px;
        padding-right: 8px;
        border-radius: 35px;
        color: white;
        font-size: 12px;
        padding-top: 5px;
        padding-bottom: 5px;

        &.-primary {
          // background-color: #3F51B5;
          background-color: #3f7fb5;
          // margin-right: 5px;
          margin-right: 3px;
        }

        &.-delete {
          // background-color: #11258c;
          background-color: #1c64a0;
          padding-left: 4px;
          padding-right: 4px;
          padding-top: 2px;
          padding-bottom: 2px;
          margin-left: 3px;
          cursor: pointer;

          .material-icons {
            font-size: 11px;
          }
        }
      }
    }
  }

  .main-content {
    margin-top: 15px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.16);

    .md-gutter {
      margin: 15px 0 15px 0;

      .box-filter-search {
        margin: 10px;
        padding: 5px;
        width: 355px;
        // height: 125px;
        height: 135px;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.45);
        display: block;
        overflow-y: scroll;

        // .md-chip {
        //     width: 98%;
        //     margin: 2px 3px;
        // }

        .tab-chip {
          padding-left: 10px;
          padding-right: 8px;
          border-radius: 35px;
          color: white;
          font-size: 12px;
          padding-top: 5px;
          padding-bottom: 5px;
          display: flex;
          background-color: #3f7fb5;
          margin: 2px;

          .-primary {
            margin-right: 5px;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
          }

          &.-delete {
            // background-color: #11258c;
            background-color: #1c64a0;
            padding-left: 4px;
            padding-right: 4px;
            padding-top: 2px;
            padding-bottom: 2px;
            margin-left: 3px;
            cursor: pointer;

            .material-icons {
              font-size: 11px;
            }
          }
        }

        &::-webkit-scrollbar {
          height: 7px;
          width: 5px;
        }
      }

      .md-layout-item {
        .md-search-box {
          // margin: 10px 0px 10px 0px;
          margin: auto;
          padding-top: unset;
          width: 100%;
          border-radius: 3px;
          min-height: 36px; // min-height: 5.3vmin;
          // max-height: 5.3vmin;
          box-shadow: 0 0 3px rgba(0, 0, 0, 0.45), 0 0 0 rgba(0, 0, 0, 0),
            0 1px 1px -2px rgba(0, 0, 0, 0);

          .md-icon.material-icons {
            margin-left: 10px; // padding-top: 8px;
            margin-top: 7px;
            color: rgba(0, 0, 0, 0.54); // font-size: 3.6vmin !important;
          }

          .md-input {
            height: 36px; // height: 5.3vmin;
            margin-left: 7px;
          }

          &.md-field > .md-icon:after,
          &.md-field:after,
          &.md-field:before {
            content: none;
          }
        }

        .right-filter-search {
          margin-top: 15px;
          display: flex;
          width: 100%;

          &.-first {
            margin-top: 25px;
          }

          .title-search {
            width: 20%;
          }

          .value-search {
            width: 85%;
          }

          .virtual-input {
            &.cust-code {
              input {
                width: 100% !important;
              }
            }

            input {
              width: 85%;
              padding-left: 8px;
              padding-right: 13.8px;
              height: 36px;
              border: 1px solid #ddd;
              border-radius: 5px;
              background: #fff;
            }

            ::placeholder {
              color: #bdbdbd;
              opacity: 1;
              font-family: kanit;
              font-size: 12px;
              font-weight: 100;
            }
          }

          .mkt-datepicker {
            // width: 95%;
            width: 100%;

            // .md-date-icon {
            //   display: none;
            // }

            input {
              font-size: 14px;
              margin: 0px;
              padding: 0px !important;
              text-align: center;
            }

            .md-field {
              padding-top: 0px;
              margin: 0px;
              min-height: 35px;

              // .md-input-action {
              //     top: 15px;
              // }
            }
          }

          .search-report {
            margin: 0px;
            // width: 120px;
            width: 100px;
            height: 35px;
            // background-color: rgb(239, 239, 239);
            // color: #727272;
            color: #ffffff;
            background-color: #3f51b5;
            border-radius: 3px;
            box-shadow: unset;
          }

          .mktops-subheader-filter {
            height: 38px;

            .md-field.box > .md-input.md-select-value,
            .md-field.box > .md-menu.md-select {
              font-size: 14px;
              width: 115.72px;
              height: 36px;
            }

            .md-field.md-field.box {
              margin-top: unset;
              margin-bottom: unset;
              padding: unset;
            }

            .md-field:after,
            .md-field:before {
              left: unset;
            }

            .md-field.box .md-input.md-input.md-select-value,
            .md-field.box label {
              font-size: 14px;
              padding-left: 12px;
              padding-top: 3px;
              color: #727272;
            }

            .md-field.box .md-select {
              background-color: #efefef;
              border-radius: 3px;
            }
          }
        }

        .md-radio.md-theme-default {
          margin: 0 15px 0 0;

          .md-radio-container,
          .md-radio-container::after {
            border-color: #3f51b5 !important;
          }
        }
        .md-radio.md-theme-default.md-checked .md-radio-container:after {
          background-color: #3f51b5 !important;
        }
        .md-radio.md-theme-default.md-checked .md-ripple {
          color: #3f51b5 !important;
        }
      }
    }
  }

  .chart-line {
    width: 100%;

    > div {
      width: unset !important;
    }
  }

  .box-detail-chart {
    margin-right: 25px;
    padding: 10px;
    font-weight: 500;

    > div {
      margin: 10px;
    }

    .-total {
      display: flex;
    }

    // .-title {
    //     width: 45%;
    // }
    .-value {
      // width: 55%;
      color: #2b93ff;
      text-align: right;
    }
  }

  #table-report {
    .row-bg-gray:hover {
      border-radius: 4px;
      background: rgba(236, 236, 235, 1);
    }

    .md-checkbox {
      display: flex;
      margin-top: 0px;
      margin-bottom: 0px;
      padding-left: 0px !important;
    }

    #divHeadList {
      width: 99.6%;
      display: -webkit-inline-box;
      font-size: 13px;
      font-weight: bold;
      margin-top: 15px;
      margin-bottom: 13px;

      div {
        // border: 1px solid pink;
        padding-left: 5px;
        padding-right: 5px;

        &.-text-right {
          text-align: right;
        }

        &.-text-center {
          text-align: center;
        }
      }
    }

    #divBodyList {
      width: 100%;
      height: calc(100vmin - 300px);
      display: block;
      overflow-y: scroll;

      > div {
        width: 100%;
        // height: 45px;
        display: -webkit-inline-box;
        padding-top: 5px;
        padding-bottom: 5px;

        div {
          // border: 1px solid pink;
          padding-left: 5px;
          padding-right: 5px;
          // height: 36px;
          height: 30px;
          display: table;

          span {
            vertical-align: middle;
            // display: table-cell;
          }

          &.-text-right {
            text-align: right;
          }

          &.-text-center {
            text-align: center;
          }

          &.nowrap-title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
          }

          &.-font-kanit {
            font-size: 14px;
            font-family: kanit;
            font-weight: 300;
          }
        }
      }

      .circle-green {
        width: 36px;
        height: 36px;
        background-color: #52b6b0;
        border-radius: 50px;
        margin: auto;
      }

      &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }

    #divTableFoot {
      width: 99.5%;
      display: -webkit-inline-box;
      font-weight: bold;
      margin-top: 10px;
      // margin-bottom: 10px;

      font-size: 12px;
      font-family: Roboto;

      div {
        // border: 1px solid pink;
        padding-left: 5px;
        padding-right: 5px;

        &.-text-right {
          text-align: right;
        }

        &.-text-center {
          text-align: center;
        }
      }
    }
  }

  &::-webkit-scrollbar {
    height: 7px;
    width: 6px;
  }

  .multiselect {
    .z-index-top {
      z-index: 10;
    }

    margin: 5px 0px;

    .multiselect__single,
    .multiselect__input {
      font-size: 14px;

      div {
        display: flex;
        width: 100%;

        .-delete {
          width: 5%;

          .material-icons {
            font-size: 18px;
            margin-top: 1px;
            cursor: pointer;
            color: gray;
          }
        }
      }
    }

    .multiselect__tags {
      padding: 8px 30px 0 8px;
      border: 1px solid #c1c1c1;

      input {
        font-family: lato;
        font-weight: 300;
      }

      .multiselect__placeholder {
        margin: 0px;
      }

      ::placeholder {
        color: #bdbdbd;
        opacity: 1;
      }
    }

    .multiselect__content-wrapper {
      font-size: 14px;
      z-index: 10;
      border: 1px solid #c1c1c1;
    }

    .multiselect__option {
      min-height: 34px;
      padding: 12px 12px 0px 12px;
    }

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
  }

  .bg-overlay-unset {
    // background: rgba(0, 0, 0, 0.6);
    width: 100% !important;
    height: 100%;
    position: fixed;
    z-index: 12;
    top: 0 !important;
    left: 0 !important;
    background: unset;

    .md-progress-spinner {
      top: 50% !important;
      left: 50% !important;
    }
  }

  .ckb-report {
    .md-ripple-enter-active.md-centered {
      transition-duration: 0ms !important;
      display: none;
    }

    .md-ripple-wave.md-centered {
      animation-duration: 0ms !important;
      display: none;
    }
  }
}

.filter-dialog {
  // height: 57% !important;
  height: 370px !important;
  top: 22% !important;

  .-action {
    position: absolute;
  }
}
</style>
